<div class="simple-table-container">
  @if (withSearch()) {
    <div class="search-container">
      <coin-v2-text-input
        #input
        svgIcon="search"
        addClass="shadow"
        [placeholder]="'search'"
        (input)="onSearchChange(input.value)"></coin-v2-text-input>
    </div>
  }

  <div class="simple-table">
    <div
      class="header-row template-columns"
      [style.grid-template-columns]="templateColumns">
      @for (item of headerObjects; track item; let i = $index) {
        <div
          class="header-column"
          style="flex-wrap: wrap"
          [class.with-controls]="item.key"
          [class.overlay]="item.overlay"
          [class.overlay--start]="item.overlayStart"
          [class.overlay--end]="item.overlayEnd"
          [class.overlay--contrast]="item.overlayContrast"
          [class.inactive]="isItemInactive(item.group)"
          [class.hidden]="isItemInactive(item.group) && !isGroupStart(item, i)">
          @if (item.group) {
            <div
              class="group"
              [class.start]="isGroupStart(item, i)"
              [class.inactive]="isItemInactive(item.group)"
              [class.end]="isGroupEnd(item, i)"
              [class.end-radius]="isGroupEnd(item, i) || isItemInactive(item.group)"
              (click)="toggleInactive(item.group)">
              @if (isGroupStart(item, i)) {
                <div class="group-title">
                  <p class="bold">{{ item.group }}</p>
                </div>
              }
              @if (isGroupEnd(item, i)) {
                <mat-icon>visibility_on</mat-icon>
              }
              @if (isGroupStart(item, i) && isItemInactive(item.group)) {
                <mat-icon>visibility_off</mat-icon>
              }
            </div>
          }
          <div class="header">
            @if (item.key && !item.hideFilter) {
              <div class="filter-controls">
                @if (filterActive(item.key)) {
                  <mat-icon
                    class="clear-filter"
                    (click)="clearFilterByKey(item.key)">
                    clear
                  </mat-icon>
                }
                @if (item.filterType) {
                  <span
                    class="expand-mat-icon st-filter"
                    [class.st-filter--active]="filterActive(item.key)"
                    [class.no-sorting]="item.hideSorting"
                    [matTooltip]="item.filterTooltip"
                    (click)="showFilterOptions(item)">
                    <img
                      aria-label="filter"
                      style="width: 18px; height: 18px"
                      src="/assets/svgs/filter.svg" />
                  </span>
                }
                @if (!item.hideSorting) {
                  <div class="sort-controls">
                    <div
                      class="sort-button"
                      [ngClass]="{
                        active: sortedItemsBy['type'] === item.key && sortedItemsBy['direction'] === 'DESC'
                      }"
                      (click)="sortBy(item)">
                      <mat-icon class="expand-mat-icon icon-less">expand_less</mat-icon>
                    </div>
                    <div
                      class="sort-button"
                      [ngClass]="{
                        active: sortedItemsBy['type'] === item.key && sortedItemsBy['direction'] === 'ASC'
                      }"
                      (click)="sortBy(item)">
                      <mat-icon class="expand-mat-icon icon-more">expand_more</mat-icon>
                    </div>
                  </div>
                }
              </div>
            }
            @if (item.hide) {
              <div class="spacer"></div>
            }
            @if (!item.hide) {
              <p
                class="header-title"
                (click)="showFilterOptions(item)">
                {{ item.title }}
              </p>
            }
            @if (item.checkAll) {
              <coin-v2-checkbox
                matTooltip="Select all visible items"
                [color]="'white'"
                [(ngModel)]="item.checkAll"
                (ngModelChange)="checkAllToggle($event)"></coin-v2-checkbox>
            }

            @if (showFilter === item.key) {
              <div
                animate.enter="expand"
                animate.leave="shrink"
                class="sub-header">
                @if (item.filterType === 'date') {
                  <mat-form-field>
                    <input
                      aria-label="date input"
                      matInput
                      placeholder="From"
                      [ngModel]="
                        filterVariables[item.key + '---' + 'From'] && filterVariables[item.key + '---' + 'From'][0]
                      "
                      [max]="
                        (filterVariables[item.key + '---' + 'To'] && filterVariables[item.key + '---' + 'To'][0]) ||
                        today
                      "
                      [matDatepicker]="pickerCreatedFrom"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedFrom.open()"
                      (ngModelChange)="filterVariables[item.key + '---' + 'From'] = [$event]" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedFrom></mat-datepicker>
                  </mat-form-field>
                }
                @if (item.filterType === 'date') {
                  <mat-form-field class="date-picker">
                    <input
                      aria-label="date input"
                      matInput
                      placeholder="To"
                      [ngModel]="
                        filterVariables[item.key + '---' + 'To'] && filterVariables[item.key + '---' + 'To'][0]
                      "
                      [min]="
                        filterVariables[item.key + '---' + 'From'] && filterVariables[item.key + '---' + 'From'][0]
                      "
                      [max]="today"
                      [matDatepicker]="pickerCreatedTo"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedTo.open()"
                      (ngModelChange)="filterVariables[item.key + '---' + 'To'] = [$event]" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedTo></mat-datepicker>
                  </mat-form-field>
                }
                @if ((item.filterType === 'dropdown' || item.filterType === 'customDropdown') && item?.async) {
                  <importer-dropdown
                    [lazyLoadFn]="lazyLoadFn()"
                    [searchTarget]="item.key"
                    [withSearch]="true"
                    [multiple]="true"
                    [selectAllDisabled]="true"
                    [small]="true"
                    [(ngModel)]="filterVariables[item.key]"
                    (selectionChange)="applyFilter()"></importer-dropdown>
                }
                @if (item.filterType === 'dropdown' && !item?.async) {
                  <importer-dropdown
                    [items]="getDropdownVals(item)"
                    [withSearch]="true"
                    [multiple]="true"
                    [selectAllDisabled]="true"
                    [small]="true"
                    [sort]="false"
                    [(ngModel)]="filterVariables[item.key]"
                    (selectionChange)="applyFilter()"></importer-dropdown>
                }
                @if (item.filterType === 'input') {
                  <mat-form-field>
                    <mat-label>Please enter</mat-label>
                    <input
                      aria-label="normal input"
                      matInput
                      [(ngModel)]="filterVariables[item.key]"
                      (input)="applyFilter()" />
                  </mat-form-field>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <ngx-simplebar class="content-container primary-scrollbar-vertical simple-table no-space">
      @if (dragAndDrop()) {
        <div
          class="drop-list"
          cdkDropList
          [cdkDropListSortPredicate]="sortPredicate.bind(this)"
          (cdkDropListDropped)="onDrop($event)">
          @for (item of data; track trackByItemFn(i, item); let i = $index) {
            <div
              animate.enter="expand"
              animate.leave="shrink"
              class="content-row template-columns"
              cdkDrag
              cdkDragBoundary=".drop-list"
              [style.grid-template-columns]="!item.isSeparator ? templateColumns : 'unset'"
              [cdkDragDisabled]="item.isDragDisabled"
              [class.drag-disabled]="item.isDragDisabled"
              [cdkDragData]="item"
              [class.separator-container]="item.isSeparator">
              <ng-template
                [ngTemplateOutlet]="columnsRef"
                [ngTemplateOutletContext]="{ $implicit: item, index: i }"></ng-template>
            </div>
          }
        </div>
      } @else {
        @for (item of data; track trackByItemFn(i, item); let i = $index) {
          <div
            class="content-row template-columns"
            [style.grid-template-columns]="!item.isSeparator ? templateColumns : 'unset'"
            [class.separator-container]="item.isSeparator">
            <!-- [tableGroup]="inactiveColumns" -->
            <ng-template
              [ngTemplateOutlet]="columnsRef"
              [ngTemplateOutletContext]="{ $implicit: item, index: i }"></ng-template>
          </div>
        }
      }
    </ngx-simplebar>

    @if (dataAvailable && loading) {
      <div class="loading-no-data-container">
        <importer-app-turbine [contrast]="true"></importer-app-turbine>
      </div>
    }
    @if (!dataAvailable) {
      <div class="loading-no-data-container">
        @if (!loading && !data?.length && noDataRef) {
          <ng-template [ngTemplateOutlet]="noDataRef"></ng-template>
        }
        @if (loading) {
          <importer-app-turbine></importer-app-turbine>
        }
      </div>
    }

    <div class="action-bar">
      @if (buttonsRef) {
        <div class="button-container">
          <ng-template [ngTemplateOutlet]="buttonsRef"></ng-template>
        </div>
      }

      @if (!hidePagination()) {
        <div class="paginator">
          <mat-paginator
            #paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageChange($event)"></mat-paginator>
        </div>
      }
    </div>
  </div>
</div>
